import React from 'react';
import ToggleButton from './ToggleButton';

interface SegmentedControlProps<T extends string> {
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  className = '',
}: SegmentedControlProps<T>) {
  return (
    <div className={`inline-flex gap-1 rounded-xl bg-surface-raised p-1 ring-1 ring-line ${className}`}>
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          shape="segment"
          active={value === option.value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </ToggleButton>
      ))}
    </div>
  );
}

export default SegmentedControl;
